module.exports = __webpack_public_path__ + "static/img/photo_container.f959ee19.png";